<template>
  <div>
    <div class="hidden-sm-and-down" style="height: 200px"></div>
    <v-divider></v-divider>
    <v-row class="text-center">
      <v-col class="display-1 primary--text">Locaties</v-col>
    </v-row>
    <v-footer class="grey lighten-5">
      <v-row>
        <!--        <v-col md="3" v-for="location in this.$organization.locations">-->
        <!--          <div class="text-center primary&#45;&#45;text">{{ location.name }}</div>-->
        <!--          <div class="text-center ">{{ location.address }}</div>-->
        <!--          <div class="text-center ">{{ location.zip_code }}</div>-->
        <!--          <div class="text-center text">{{ location.phone || "-&#45;&#45;" }}</div>-->
        <!--          <div class="text-center text">-->
        <!--            <a :href="location.website">{{ location.website }}</a>-->
        <!--          </div>-->
        <!--        </v-col>-->
      </v-row>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      locations: [
        {
          name: "Soulburg",
          street: "Marie Curieweg 5",
          zipCode: "4389 WB Oost-Souburg",
          phone: "T. 0118 - 486 807"
        },
        {
          name: "Goes",
          street: "Pearyweg 9",
          zipCode: "4462 GT Goes",
          phone: "T. 0113 - 214 689"
        }
      ]
    };
  }
};
</script>

<style scoped></style>
